// services/firestore/invites.ts — Reads for the
// license_org_invites collection.

import {
  collection,
  getDocs,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { db } from '@/services/firebase';
import type { LicenseOrgInvite } from '@/types/domain';

export async function listActiveInvites(
  orgId: string,
): Promise<LicenseOrgInvite[]> {
  const q = query(
    collection(db, 'license_org_invites'),
    where('licenseOrgId', '==', orgId),
    where('status', '==', 'active'),
    orderBy('createdAt', 'desc'),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => {
    const data = d.data() as Record<string, unknown>;
    return {
      id: d.id,
      licenseOrgId: orgId,
      productId: (data.productId as string | undefined) ?? '?',
      status: 'active',
      maxUses: (data.maxUses as number | undefined) ?? 1,
      usedCount: (data.usedCount as number | undefined) ?? 0,
      redeemedByUid: (data.redeemedByUid as string | null) ?? null,
      redeemedAt:
        (data.redeemedAt as LicenseOrgInvite['redeemedAt']) ?? null,
      expiresAt: data.expiresAt as LicenseOrgInvite['expiresAt'],
      createdAt: data.createdAt as LicenseOrgInvite['createdAt'],
      createdByUid: (data.createdByUid as string | undefined) ?? '',
      note: (data.note as string | undefined) ?? '',
    };
  });
}
